import { useState } from "react"

import ApiKeyScreen from "./components/ApiKeyScreen"
import ProjectsScreen from "./components/ProjectsScreen"
import SearchScreen from "./components/SearchScreen"

import ProMindLogo from "./components/branding/ProMindLogo"

import { getApiKey } from "./storage/apiKey"

export default function App() {

  const [apiKey, setApiKey] = useState(getApiKey())
  const [project, setProject] = useState(null)

  return (

    <div style={styles.appRoot}>

      <div style={styles.gridBackground} />

      <div style={styles.contentLayer}>

        <header style={styles.header}>

          <ProMindLogo size="normal" />

        </header>

        <main style={styles.main}>

          {/* 1. Ingen API-nyckel */}

          {!apiKey && (
            <ApiKeyScreen
              onSaved={setApiKey}
            />
          )}

          {/* 2. Projektval */}

          {apiKey && !project && (
            <ProjectsScreen
              apiKey={apiKey}
              onSelectProject={setProject}
            />
          )}

          {/* 3. Search */}

          {apiKey && project && (
            <SearchScreen
              apiKey={apiKey}
              project={project}
              onBack={() => setProject(null)}
            />
          )}

        </main>

      </div>

    </div>

  )
}

const styles = {

  appRoot: {
    minHeight: "100vh",

    background: "#F3F2EF",

    position: "relative",

    overflow: "hidden",

    fontFamily: "system-ui, sans-serif",
  },

  gridBackground: {
    position: "fixed",

    inset: 0,

    backgroundImage: `
      linear-gradient(rgba(31,31,31,0.035) 1px, transparent 1px),
      linear-gradient(90deg, rgba(31,31,31,0.035) 1px, transparent 1px)
    `,

    backgroundSize: "120px 120px",

    pointerEvents: "none",

    zIndex: 0,
  },

  contentLayer: {
    position: "relative",

    zIndex: 1,
  },

  header: {
    padding: "32px 40px 20px",
  },

  main: {
    maxWidth: 760,

    margin: "0 auto",

    padding: "0 24px 80px",
  },

}
